import './components/jquery';
import './components/events';
import './components/checkErrors';

import Header from './components/header';
//import SplashScreen from './components/splash-screen';
import ArticleSlider from './components/article-slider';
import MainNews from './components/main-news';
import HeaderLive from './components/header-live';
import SearchForm from './components/search-form';
import ListNews from './components/list-news';
import InfinityScroll from './components/infinity-scroll';
import VideoList from './components/video-list';
import SocialShare from './components/social-share';
import VideoScrollControl from './components/video-scroll-control';
import LazyImages from './components/lazy-images';
import PlayerStarter from './components/player-starter';

class App {
    constructor() {

        let $videoLists = document.querySelectorAll('.list-videos, .list-more-videos');
        let $headerLive = document.querySelectorAll('.header-live');
        let $share      = document.querySelectorAll('.share');
        this.header             = new Header();
        // this.splashScreen       = new SplashScreen({
        //         name:  'Ещё удобнее в нашем приложении',
        //         anons: 'Продолжить на сайте',
        //         href:  ''
        //     }
        // );
        this.mainNews           = new MainNews(document.querySelector('.main-news__wrapper'));
        this.articleSlider      = new ArticleSlider(document.querySelector('.article__slider_top'));
        this.searchForm         = new SearchForm(document.querySelector('.search-ext'));
        this.listNews           = new ListNews(document.querySelector('.list-news'));
        this.infinityScroll     = new InfinityScroll();
        this.videoScrollControl = new VideoScrollControl();

        let $articleTitle = document.querySelector('.article__title');

        this.headerLive  = [ ...$headerLive ].map($section => new HeaderLive($section));
        this.videoList   = [ ...$videoLists ].map($section => new VideoList($section));
        this.socialShare = [ ...$share ].map($block => new SocialShare($block, window.location.href, $articleTitle ? $articleTitle.innerText : null));

        new LazyImages(document.querySelectorAll('img.vgtrk-lazy'));
        new PlayerStarter();

        // console.log($('img.vgtrk-lazy'))

        // $('img.vgtrk-lazy').Lazy({
        //     beforeLoad($el) {
        //         console.log(`Start loading ${$el}`);
        //     },
        //     afterLoad($el) {
        //
        //         console.log(`End loading ${$el}`);
        //
        //         let $preloader = $el.parents('.vgtrk-lazy-preloader');
        //
        //
        //         $preloader.removeClass('vgtrk-lazy-preloader');
        //         $el.removeClass('vgtrk-lazy');
        //     }
        // });

        $('.vgtrk-a1').on('click', function () {
            var banId = $(this).data('id');
            gtag('event', 'click', {
                'event_category': 'dvrt',
                'event_label':    banId
            });
        });

    }
}

new App();


